import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  booleanAttribute,
} from '@angular/core';

@Component({
  selector: 'sigecom-input-search',
  template: `
    <div class="rounded-md shadow-flat-xl overflow-hidden flex relative">
      <input
        class="h-full w-full rounded-s-md bg-white outline-none border border-white
      focus:border focus:border-cbde-primary"
        #searchInput
        [(ngModel)]="search"
        debouncedInput
        (debouncedInput)="onSearchChange($event)"
        placeholder="{{ placeholder || 'Pesquisar...' }}"
       
      />
      <fa-icon
        class="text-sigecom-info cursor-pointer absolute right-11 top-1.5"
        (click)="onClear()"
        *ngIf="search.length > 0"
        [icon]="'xmark'"
      />
      <div
        class="bg-sigecom-gray text-white cursor-pointer flex items-center px-1.5 border border-sigecom-gray"
        (click)="onSearchChange(searchInput.value)"
      >
        <fa-icon [icon]="'magnifying-glass'"></fa-icon>
      </div>
    </div>
    <div *ngIf="errorMessage" class="text-sigecom-danger pt-2 text-sm">
      <small>{{ errorMessage }}</small>
    </div>
  `,
})
export class InputSearchComponent {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  @Input() placeholder?: string;
  @Input() search: string = '';
  @Input({ transform: booleanAttribute }) lowercase: boolean = false;
  @Input() errorMessage?: string;
  @Output() searchChange: EventEmitter<any> = new EventEmitter<
    string | undefined
  >();


  onSearchChange(newValue: string) {
    console.log(' Search changed:', newValue);
    if (newValue === '') {
      this.searchChange.emit(undefined);
     // this.search = newValue;
      return;
    }
    //this.search = newValue;
    this.searchChange.emit(newValue);
    // this.searchChange.emit(
    //   this.lowercase ? newValue : this.search.toUpperCase()
    // );
  }
  onClear() {
    this.searchChange.emit(undefined);
    this.searchInput.nativeElement.value = '';
    return;
  }

 /* @HostListener('input', ['$event'])
  onInput(event: Event) {
  
  const value = (event.target as HTMLInputElement).value;
  this.searchChange.emit(value || undefined);
}*/
}
